//region block: pre-declaration
//endregion
function get_DISABLE_SFG() {
  return DISABLE_SFG;
}
var DISABLE_SFG;
//region block: init
DISABLE_SFG = false;
//endregion
//region block: exports
export {
  get_DISABLE_SFG as get_DISABLE_SFGk0o6djov1myf,
};
//endregion

//# sourceMappingURL=PipelineContext.js.mjs.map
